import { useQuery } from '@tanstack/react-query';

import { kubesoloVersionList } from '@api/sdk.gen';

import { withError } from '@/react-tools/react-query';

import { queryKeys } from './queryKeys';

/** Portainer itself keeps GitHub's release list for up to an hour, so a few minutes here only spares it repeat requests. */
const STALE_TIME_MS = 5 * 60 * 1000;

export function useKubesoloVersions() {
  return useQuery({
    queryKey: queryKeys.versions(),
    queryFn: async () => {
      const { data } = await kubesoloVersionList();
      return data;
    },
    staleTime: STALE_TIME_MS,
    ...withError('Unable to load the KubeSolo versions'),
  });
}
